<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf">
      <div class="mb25">
        回复的内容：
        <a-checkbox v-model:checked="text">文字</a-checkbox>
        <a-checkbox v-model:checked="image">图片</a-checkbox>
        <a-checkbox v-model:checked="graphic">图文</a-checkbox>
        <a-checkbox v-model:checked="minicard">小程序卡片</a-checkbox>
        <a-checkbox v-model:checked="audio">音频</a-checkbox>
        <a-checkbox v-model:checked="video">视频</a-checkbox>
      </div>
      <div class="s_bor10 s_bor_cbed s_over_h mb25" v-if='text'>
        <div class="height-50 s_ptb0lr24 s_flex_bian_c s_bf58">
          <p class="fz-18 s_font_b s_c333">回复文字</p>
          <div class="s_flex_ali">
            <p class="s_c666 m-r-10">{{title}}</p>
            <a-tooltip>
              <template #title>
                {{qpText}}
              </template>
              <QuestionCircleOutlined class="s_c376" />
            </a-tooltip>
          </div>
        </div>
        <div class="">
          <a-textarea class="borNone" v-model:value="form.text" showCount :maxlength="600" :rows="8"
            placeholder='请输入' />
        </div>
      </div>
      <div class="s_bor10 s_bor_cbed s_over_h mb25" v-if='image'>
        <div class="height-50 s_ptb0lr24 s_flex_bian_c s_bf58">
          <p class="fz-18 s_font_b s_c333">回复图片</p>
        </div>
        <div class="p-20 s_flex_di">
          <div class="imgTextBox s_flex_center width49 s_po_re">
            <img v-if='form.image_detail.file_url' class="width100" style="height: 100%;"
              :src="form.image_detail.file_url.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+form.image_detail.file_url : form.image_detail.file_url"
              alt="">
            <div class="text-ac" v-if='!form.image_detail.file_url'>
              <PlusOutlined class="s_c999 fz-40" />
              <p class="s_c999">从素材库中选择</p>
            </div>
            <div class="s_po_ab_tl s_tou" v-if='!form.image_detail.file_url'>
              <wxMaterial :size='{width:621,height:250}' :groupType='1' :image="form.image_detail.file_url" :max="1"
                v-on:handlechoose="(data)=>{form.image_detail.file_url=data.imageUrl;form.image=data.data.media_id;}"
                v-on:handledel="form.image='';form.image_detail.file_url=''" />
            </div>
          </div>
          <a-button type="link" v-if='form.image_detail.file_url'
            @click="()=>{form.image='';form.image_detail.file_url=''}">删除</a-button>
        </div>
      </div>
      <div class="s_bor10 s_bor_cbed s_over_h mb25" v-if='graphic'>
        <div class="height-50 s_ptb0lr24 s_flex_bian_c s_bf58">
          <p class="fz-18 s_font_b s_c333">回复图文</p>
        </div>
        <div class="p-20 s_flex_di" v-if='form.graphic'>
          <div class="width30 p-tb0-lr20 s_bor_cd9">
            <p class="height-52 s_flex_ali s_bor_b_cd9 m-b-15">{{form.graphic_detail.create_time}}</p>
            <img class="width100 height-250"
              :src="form.graphic_detail.list[0].image.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+form.graphic_detail.list[0].image : form.graphic_detail.list[0].image"
              alt="">
            <p class="height-52 s_flex_ali">{{form.graphic_detail.list[0].title}}</p>
          </div>
          <a-button type="link" v-if='form.graphic' @click="()=>{form.graphic='';form.graphic_detail={}}">删除</a-button>
        </div>
        <div class="p-20 s_flex_bian_c" v-else>
          <div class="imgTextBox s_flex_center width49" @click='graphicVisible = true'>
            <div class="text-ac">
              <PlusOutlined class="s_c999 fz-40" />
              <p class="s_c999">从素材库中选择</p>
            </div>
          </div>
          <div class="imgTextBox s_flex_center width48"
            @click="$router.push('/wxPublic/wxManagement/drewManagement/wx_imgText_add?type=add')">
            <div class="text-ac">
              <PlusOutlined class="s_c999 fz-40" />
              <p class="s_c999">新建图文消息</p>
            </div>
          </div>
        </div>
      </div>
      <div class="s_bor10 s_bor_cbed s_over_h mb25" v-if='minicard'>
        <div class="height-50 s_ptb0lr24 s_flex_bian_c s_bf58">
          <p class="fz-18 s_font_b s_c333">回复小程序卡片</p>
          <p class="s_c666">发送小程序卡片，请先将公众号关联小程序，<a-button type="link">查看关联教程</a-button>
          </p>
        </div>
        <div class="p-20 s_flex_di" v-if='form.minicard'>
          <div class="width30 p-tb0-lr20 s_bor_cd9">
            <p class="height-52 s_flex_ali s_bor_b_cd9 m-b-15">{{form.minicard_detail.create_time}}</p>
            <img class="width100 height-250"
              :src="form.minicard_detail.image.indexOf(info.picdomain) == -1 ? info.picdomain+'/'+form.minicard_detail.image : form.minicard_detail.image"
              alt="">
            <p class="height-52 s_flex_ali">{{form.minicard_detail.title}}</p>
          </div>
          <a-button type="link" v-if='form.minicard' @click="()=>{form.minicard='';form.minicard_detail={}}">删除
          </a-button>
        </div>
        <div class="p-20 s_flex_bian_c" v-else>
          <div class="imgTextBox s_flex_center width49" @click='minicardVisible = true'>
            <div class="text-ac">
              <PlusOutlined class="s_c999 fz-40" />
              <p class="s_c999">从素材库中选择</p>
            </div>
          </div>
          <div class="imgTextBox s_flex_center width48"
            @click="$router.push('/wxPublic/wxManagement/drewManagement/wx_card_add?type=add')">
            <div class="text-ac">
              <PlusOutlined class="s_c999 fz-40" />
              <p class="s_c999">新建小程序卡片</p>
            </div>
          </div>
        </div>
      </div>
      <!-- 音频 -->
       <div class="s_bor10 s_bor_cbed s_over_h mb25" v-if='audio'>
         <div class="height-50 s_ptb0lr24 s_flex_bian_c s_bf58">
          <p class="fz-18 s_font_b s_c333">回复音频</p>
        </div>
        <div class="p-20 s_flex_di">
          <!--  -->
              <div class="audio_select" v-if="!audioData.media_id"  @click="audioType=true">
                   <plus-outlined style="fontSize:18px"></plus-outlined>
                   <p class="m-t-10">选择音频</p>
                </div>
                <div class="select_success" v-else>
                   <div class="audio_success">
                     <img src="@/assets/images/audio.png" alt="" width="100" height="96">
                     <div class="m-l-10 flex_1 s_flex_ali">
                       <p class="s_omit2 flex_1">{{audioData.name || '无'}}</p>
                     </div>
                   </div>
                   <div class="m-l-20" >
                     <span style="color:#05486A" class="cursor_p" @click="delAudio">删除</span>
                   </div>
               </div>
        </div>
       </div>
       <!-- 视频 -->
        <div class="s_bor10 s_bor_cbed s_over_h mb25" v-if='video'>
         <div class="height-50 s_ptb0lr24 s_flex_bian_c s_bf58">
          <p class="fz-18 s_font_b s_c333">回复视频</p>
        </div>
        <div class="p-20 s_flex_di">
          <!--  -->
             <div class="s_flex_center s_mauto m-t-20 m-b-50" style="width:50%">
               <a-input v-model:value="videoData.wx_file_url" placeholder="请选择视频链接" style="flex:1"/>
               <a-button type="primary" class="m-l-10" @click="videoType=true">选择</a-button>
               <a-button type="primary" class="m-l-10 copy-btn" :data-clipboard-text="videoData.wx_file_url"  @click="copy()">复制链接</a-button>
             </div>
        </div>
       </div>

      <a-button class="width-100 m-r-20" type="primary" @click='onSubmit("add")'>保存</a-button>
      <a-button class="width-100 m-r-20" type="primary" ghost @click='onSubmit("del")'>删除回复</a-button>
      <div class="height-30"></div>
    </div>
  </a-layout>
  <a-modal  :keyboard="false" title="选择图文" :width='1300' centered :footer="null" v-model:visible="graphicVisible" destroyOnClose>
    <graphic v-on:success='success' v-on:cancel='graphicVisible = false' />
  </a-modal>
  <a-modal  :keyboard="false" title="选择小程序卡片" :width='1300' centered :footer="null" v-model:visible="minicardVisible" destroyOnClose>
    <minicard v-on:success='successMini' v-on:cancel='minicardVisible = false' />
  </a-modal>

     <a-modal  :keyboard="false" title="选择音频" :width='1300' centered :footer="null" v-model:visible="audioType" destroyOnClose>
    <audioModal @change="audioSelect"></audioModal>
  </a-modal>

   <a-modal :keyboard="false" title="选择视频" :width='1300' centered :footer="null" v-model:visible="videoType" destroyOnClose>
    <videoModal :videoID='videoData.id'   @change="videoSelect"></videoModal>
  </a-modal>
</template>

<script>
  import { QuestionCircleOutlined, PlusOutlined, } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { iscode } from "@/utils/app";
  import { message } from 'ant-design-vue';
  import { setwx_reply, getwx_reply } from '@/api/public_wx'
  import store from "@/store";
  import audioModal from '../../menu/components/audioModal.vue';
    import videoModal from '../../menu/components/videoModal.vue';
      import Clipboard from 'clipboard';
  // 初始化默认筛选项数值
  let defForm = {
    text: '',
    image: '',
    graphic: {},
    minicard: '',
    image_detail: {
      file_url:""
    },
    graphic_detail: {},
    minicard_detail: {},
    voice:'',
    video:''
  }
  export default {
    components: {
      QuestionCircleOutlined, PlusOutlined,audioModal,videoModal
    },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        graphicVisible: false,
        minicardVisible: false,
        info: store.state.user.info,
        text: false,
        image: false,
        graphic: false,
        minicard: false,
        audio:false,
        video:false,
        audioType:false,
        videoType:false,
        audioData:{},
        videoData:{id:null},
        title: '文字回复可以用标签 <#微信昵称#> 显示会员微信昵称哦~',
        qpText: '后台设置：<#微信昵称#>终于等到你！ 用户关注后：高大永恒塑料制品有限公司后台 终于等到你！',
      })
      const $route = inject('$route')
      const $router = inject('$router')
      // 获取信息
      const getMore = async () => {
        const hide = message.loading('正在加载中...', 0);
        let res = await getwx_reply({key:'follow_auto_reply'}).then(res => res.data);
        if (iscode(res)) {
          form.value = res.data
          form.value.image_detail=form.value.image_detail || {}
          state.text = res.data.text ? true : false
          state.image = res.data.image ? true : false
          state.graphic = res.data.graphic ? true : false
          state.minicard = res.data.minicard ? true : false
          state.audio = res.data.voice? true : false
          state.video = res.data.video? true : false
          state.audioData = res.data.voice_detail || {};
          state.videoData = res.data.video_detail || {};
          setTimeout(hide);
        } else {
          message.error(res.msg);
          setTimeout(hide);
        }
      }
      //选择图文
      const success = (e) => {
        form.value.graphic_detail = e
        form.value.graphic = {
          graphic_type: e.media_id ? 1 : 2,
          graphic_id: e.id
        }
        state.graphicVisible = false
      }
      //选择小程序卡片
      const successMini = (e) => {
        form.value.minicard_detail = e
        form.value.minicard = e.id
        state.minicardVisible = false
      }
      //保存
      const onSubmit = async (type) => {
        const hide = message.loading('正在加载中...', 0);
        if (type == 'del') {
          state.text = false
          state.image = false
          state.graphic = false
          state.minicard = false
          state.audio = false
          state.video = false
        }
        let res = await setwx_reply({
          ...form.value,
          key: 'follow_auto_reply',
          text: state.text ? form.value.text : '',
          image: state.image ? form.value.image : '',
          graphic: state.graphic ? JSON.stringify(form.value.graphic) : '',
          minicard: state.minicard ? form.value.minicard : '',
           voice: state.audio ? form.value.voice:'',
           video: state.video? form.value.video:'',
        }).then(res => res.data);
         getMore()
        setTimeout(hide);
            message.success(res.msg);
      }
      const delAudio = function(){
          state.audioData = {};
          form.value.voice = ''
      }

      const audioSelect = function(data){
            state.audioData = data || {};
            form.value.voice = data.media_id
            state.audioType = false;
        
      }

      const videoSelect = function(data){
          state.videoData = data || {};
          form.value.video = data.media_id || '';
          console.log(data)
          state.videoType = false
      }

      const copy = function(){
            let clipboard = new Clipboard(".copy-btn"); // 这里括号里填写上面点击事件绑定的class名
            clipboard.on("success", e => {
               message.success("复制成功")
               // 释放内存
               clipboard.destroy();
            });
      }
      onMounted(() => {
        getMore();
      })
      return {
        ...toRefs(state),
        form,
        onSubmit,
        success, 
        successMini,
        delAudio,
        audioSelect,
        videoSelect,
        copy
      }
    }
  }
</script>
<style lang="less" scoped>
  .borNone {
    border: 0 !important;
  }

  .imgTextBox {
    height: 250px;
    border: 1px dashed #e7e7eb;
    cursor: pointer
  }

  .imgTextBox:hover {
    border: 1px dashed #05486A;
  }
  .audio_select{
  width:400px;
  height: 120px;
  border: 1px dashed #999;
  text-align: center;
  padding: 30px 0 30px;
  background: #f8f8f8;
  color: #999;
  margin: 20px auto 40px;
  cursor: pointer;
  &:hover{
   border: 1px dashed #333;
   color: #333;
  }
}
.select_success{
  width:460px;
  display: flex;
  margin: 20px auto 40px;
  align-items: center;
 & .audio_success{
  width: 404px;
  height: 104px;
   border: 2px solid #eee;
   overflow: hidden;
   display: flex;
    -webkit-user-select: none;
 -moz-user-select: none;
 -ms-user-select: none;
 user-select: none;
 padding: 2px;
 border-radius: 5px;
}
}
</style>